import { Flex, Select } from "antd";
import React from "react";

const Dropdown = ({
  name = "",
  value = "",
  label = "",
  onChange,
  options = [],
}) => {
  return (
    <Flex gap={16}>
      <label style={{ width: "45%" }} htmlFor={name}>
        {label}
      </label>
      <Select
        style={{ width: "100%" }}
        options={options}
        value={value}
        id={name}
        onChange={onChange}
        showSearch
      />
    </Flex>
  );
};

export default Dropdown;
